import { Flex } from '@mantine/core'
import { useRouter } from 'next/router'
import { useMemo, useContext } from 'react'

import { useAnalytics } from '@flecto/analytics'
import { useTranslation } from '@flecto/translations'
import { type CoreBookingDocument } from '@flecto/types'
import { Badge, Modal } from '@flecto/ui'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'
import { ModalsContext } from '@flecto/ui/src/components/Modal/ModalsProvider'

import { useBookingDocumentActions } from '../../hooks/useBookingDocumentActions'
import { UploadDocumentCard } from '../UploadDocumentCard/UploadDocumentCard'

export function ModalViewDocument() {
  const { t: tBooking } = useTranslation('saas', { keyPrefix: 'booking' })
  const { closeModal } = useContext(ModalsContext)
  const { change, files, view, deleteDocument } = useBookingDocumentActions()
  const { isMobile } = useMediaQuery()
  const track = useAnalytics('segment')
 
  if (!files?.length) {
    closeModal()
  }

  const router = useRouter()

  const handleView = (file: CoreBookingDocument) => {

    view(file.url)
    track('BOOKING_DOCUMENT__VIEW', {
      booking_id: router.query.id ? Number(router.query.id) : '',
      filename: file?.filename_base ?? '',
      type: file?.type ?? '',
      category: file?.category ?? '',
      generated: file.generated ?? false,
    })
  }

  return (
    <Modal size={isMobile ? 'md' : 'xxl'} variant='default'>
      <Modal.Close />
      <Modal.Title>
        {tBooking('booking_documents.title')}
        {Boolean(files?.length) && (
          <Badge color='gray' size='sm'>
            {files?.length}
          </Badge>
        )}
      </Modal.Title>
      <Modal.Content>
        <Flex direction={'column'} gap={'md'}>
          {files?.map((document: CoreBookingDocument) => (
            <UploadDocumentCard
              document={document}
              key={document.id}
              onView={() => handleView(document)}
              onDelete={() => deleteDocument(document.id as string)}
              onChange={(field, value) =>
                change(document.id as string, field, value)
              }
            />
          ))}
        </Flex>
      </Modal.Content>
    </Modal>
  )
}
